module.exports = __webpack_public_path__ + "static/media/warning-alert.ef079ed4.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/MyProfile/warning-alert.png
// module id = 3013
// module chunks = 0